import { render, staticRenderFns } from "./other-fees.vue?vue&type=template&id=d1dadfa4"
import script from "./other-fees.vue?vue&type=script&lang=js"
export * from "./other-fees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports